import { getTimeZones } from 'lib/timeZones';
import { useReduxState } from 'hooks';
import { localeNames } from 'shared-locales';
import { Checkbox, Code, FormGroup, Select } from 'components/common/form';
import { SiteSettingsForm } from '.';

const SiteSettingsLocalization = () => {
  const { messages, serverConfig } = useReduxState();

  const {
    customAdminLocales,
    defaultInterfaceLanguage,
    defaultSystemLanguage,
    supportedLanguages,
    timeZone
  } = serverConfig;

  const timeZones = getTimeZones();

  const updateValuesBeforeSubmit = async (values) => {
    const newValues = { ...values };

    newValues.customAdminLocales = JSON.parse(
      newValues.customAdminLocales || '{}'
    );

    newValues.supportedLanguages = Object.keys(
      newValues.supportedLanguages
    ).filter((key) => newValues.supportedLanguages[key]);

    if (newValues.defaultInterfaceLanguage === 'default') {
      newValues.defaultInterfaceLanguage = null;
    }

    return newValues;
  };

  const initialValues = {
    customAdminLocales: customAdminLocales
      ? JSON.stringify(customAdminLocales, null, 2)
      : '',
    defaultInterfaceLanguage: defaultInterfaceLanguage || 'default',
    defaultSystemLanguage: defaultSystemLanguage,
    supportedLanguages: Object.keys(localeNames).reduce((languages, locale) => {
      languages[locale] = supportedLanguages.includes(locale);
      return languages;
    }, {}),
    timeZone
  };

  return (
    <div className="settings-localization">
      <SiteSettingsForm
        initialValues={initialValues}
        title={messages.siteSettingsLanguageAndTime}
        updateValuesBeforeSubmit={updateValuesBeforeSubmit}
      >
        {(formState) => (
          <div>
            <FormGroup label={messages.siteSettingsSupportedLanguages}>
              {Object.keys(localeNames).map((locale) => (
                <Checkbox
                  key={locale}
                  field={`supportedLanguages['${locale}']`}
                  id={`language-${locale}`}
                  label={localeNames[locale]}
                  style={{ marginBottom: 5 }}
                />
              ))}
            </FormGroup>

            <FormGroup label={'Default system language'} maxWidth="320px">
              <Select
                field="defaultSystemLanguage"
                id="default-system-language"
                options={[
                  ...Object.keys(localeNames)
                    .filter(
                      (key) => formState.values?.supportedLanguages?.[key]
                    )
                    .map((locale) => ({
                      label: localeNames[locale],
                      value: locale
                    }))
                ]}
              />
            </FormGroup>

            <FormGroup label={'Default interface language'} maxWidth="320px">
              <Select
                field="defaultInterfaceLanguage"
                id="default-interface-language"
                options={[
                  { label: 'Browser language', value: 'default' },
                  ...Object.keys(localeNames)
                    .filter(
                      (key) => formState.values?.supportedLanguages?.[key]
                    )
                    .map((locale) => ({
                      label: localeNames[locale],
                      value: locale
                    }))
                ]}
              />
            </FormGroup>

            <FormGroup label={messages.commonTimeZone} maxWidth="320px">
              <Select
                field="timeZone"
                id="time-zone"
                isSearchable={true}
                options={timeZones}
              />
            </FormGroup>

            <FormGroup label={'Custom locales'}>
              <Code
                error={formState?.errors?.customAdminLocales}
                field="customAdminLocales"
                placeholder={JSON.stringify(
                  {
                    'en-GB': { authVuoAccount: 'External users' },
                    'fi-FI': { coursesMyCourses: 'Omat materiaalit' }
                  },
                  null,
                  2
                )}
                rows={8}
                validateJSON={true}
              />
            </FormGroup>
          </div>
        )}
      </SiteSettingsForm>
    </div>
  );
};

export default SiteSettingsLocalization;
